import React, { useState } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { v1 as uuidv1 } from 'uuid';

// type TooltipCssProps = { maxWidthPx?: number } & TooltipRefProps;

// Hotfix https://github.com/wwayne/react-tooltip/issues/769 (Tooltip is not hiding.)
// But also no need to render anything in DOM until needed.
// const StyledTooltip = styled(ReactTooltip)<any>`
//   font-size: var(--medium);
//   line-height: 1.5;
//   letter-spacing: initial;
//   font-weight: normal;
//   text-transform: none;
//   overflow: hidden;
//   position: relative;
//   z-index: 999999;
//   max-width: ${({ maxWidthPx }) =>
//     maxWidthPx ? `${maxWidthPx}px` : 'initial'};

//   .isMobileStyle & {
//     /* force wrap required to not overflow viewport */
//     white-space: normal;
//     max-width: ${({ maxWidthPx }) =>
//       maxWidthPx ? `${maxWidthPx}px` : '350px'};
//   }
//   /* &.type-info {
//     background-color: var(--black1);
//     border-color: var(--gray1);
//     &::after {
//       border-top-color: var(--gray1) !important;
//     }
//   } */
// `;

type TooltipProps = {
  text?: string;
  type?: 'info' | 'warning' | 'error' | 'success';
  className?: string;
  // style?: {};
  maxWidthPx?: number;
  children: React.ReactNode;
  wrapper?: 'p' | 'div' | 'inlineDiv' | 'span';
  // tooltipProps?: TooltipRefProps;
  pointer?: boolean;
};

/**
 * Info Bubble which floats above wrapped component on hover
 *
 * @See https://www.npmjs.com/package/react-tooltip
 */
const Tooltip = ({
  text,
  type,
  // style,
  className,
  maxWidthPx = 450,
  children,
  wrapper,
  // tooltipProps,
  pointer,
}: TooltipProps) => {
  const [id] = useState(uuidv1());
  const [tooltip, showTooltip] = useState(true);

  if (!text) {
    return <>{children}</>;
  }

  const tooltipStyle = {
    cursor: pointer ? 'pointer' : undefined,
    fontFamily: 'var(--standardFontFamily)',
  };

  return (
    <>
      {wrapper === 'div' || wrapper === 'inlineDiv' ? (
        <div
          className={className}
          data-tooltip-content={text}
          data-type={type || 'info'}
          data-tooltip-id={id}
          style={
            wrapper === 'inlineDiv'
              ? {
                  ...tooltipStyle,
                  display: 'inline-block',
                }
              : tooltipStyle
          }
          onMouseEnter={() => showTooltip(true)}
          onMouseLeave={() => {
            showTooltip(false);
            setTimeout(() => showTooltip(true), 50);
          }}
        >
          {children}
        </div>
      ) : wrapper === 'p' ? (
        <p
          className={className}
          data-tooltip-content={text}
          data-type={type || 'info'}
          data-tooltip-id={id}
          style={tooltipStyle}
          onMouseEnter={() => showTooltip(true)}
          onMouseLeave={() => {
            showTooltip(false);
            setTimeout(() => showTooltip(true), 50);
          }}
        >
          {children}
        </p>
      ) : (
        <span
          className={className}
          data-tooltip-content={text}
          data-type={type || 'info'}
          data-tooltip-id={id}
          style={tooltipStyle}
          onMouseEnter={() => showTooltip(true)}
          onMouseLeave={() => {
            showTooltip(false);
            setTimeout(() => showTooltip(true), 50);
          }}
        >
          {children}
        </span>
      )}
      {tooltip && (
        <ReactTooltip
          id={id}
          // {...tooltipProps}
          // border={1}
          style={{
            fontSize: 'var(--medium)',
            fontFamily: 'var(--standardFontFamily)',
            lineHeight: 1.5,
            letterSpacing: 'initial',
            fontWeight: 'normal',
            textTransform: 'none',
            maxWidth: maxWidthPx ? `${maxWidthPx}px` : 'initial',
            // Make sure it's above Table header (and similar elements)
            zIndex: 999999,
          }}
          // render={() => (<>Test <br /> nextline</>)}
        />
      )}
    </>
  );
};

export default Tooltip;
